import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AdminForm from "../../AdminForm";
import { selectLoading } from "features/admin/Tags/tagsAdminSlice";
import {
  selectPromo,
  fetchPromo,
  setPromo,
  updatePromo,
} from "../promoAdminSlice";
import Preloader from "components/Preloader/Preloader";
import styled from "styled-components/macro";

const EditPromo = () => {
  const [progress, setProgress] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const promo = useSelector(selectPromo);
  const isLoading = useSelector(selectLoading);
  const navigate = useNavigate();
  useEffect(() => {
    !isLoading && dispatch(fetchPromo(id));
    return () => {
      dispatch(setPromo(undefined));
    };
  }, [id]);

  const onSubmit = (data: any) => {
    dispatch(
      updatePromo({ ...data, id }, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return !isLoading ? (
    <AdminForm
      formTitle="Промяна на промоция"
      onSubmit={onSubmit}
      product={promo}
      progress={progress}
    />
  ) : (
    <LoaderWrapper>
      <Preloader />
    </LoaderWrapper>
  );
};

export default EditPromo;
const LoaderWrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: inline-flex;
  justify-content: center;
`;
